import React from 'react'

export const TextLabel = ({ text, className }) => {
  return (
    <h1 className={`uppercase text-[24px] lg:text-[40px] font-anton text-[#417ABD] ${className}`}>{text}</h1>
  )
}